import { render, staticRenderFns } from "./TrueWind.vue?vue&type=template&id=7a36d90d&"
import script from "./TrueWind.vue?vue&type=script&lang=js&"
export * from "./TrueWind.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports